import Marquee from "react-fast-marquee";

export default function SignatureMarquee({ card }) {
  const words = [card.name, card.title.split(" ")[0], "Available for work", card.company];
  return (
    <section className="border-y border-white/10 py-8 md:py-12" data-testid="signature-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-stroke px-8 text-6xl font-semibold tracking-tight md:text-8xl">
              {w}
            </span>
            <span className="text-3xl text-white/30 md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
